<template>
  <div class="add-visit-person">
    <title-bar
      :title="isEdit ? $t('Gattaran_0_Edit_contacts_nCLZ' /** 编辑联系人 */) : $t('Gattaran_0_Create_new_Faau' /** 新建联系人 */)"
      showBack
      @back="back"
    />
    <div
      v-if="!hasNotificationCloseCache && notificationShow"
      ref="notification"
      class="notification"
    >
      <p><i class="icon-outlined_information"></i>{{$t('Gattaran_0_Maximum_number_pgYM' /** 每种角色最多新建一个人 */)}}</p>
      <i class="richic-close" @click="closeNotification"></i>
    </div>
    <div class="add-visit-person-list-wrapper">
      <soda-form
        class="add-visit-person-form"
        ref="form"
        v-if="dataLoaded"
        v-model="formData"
        :config="formConfig"
      />
    </div>
    <div class="save">
      <rich-button class="save-btn" @click="save" :loading="loading">
        <span>{{ gettext('保存') }}</span>
      </rich-button>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import TitleBar from '@/components/TitleBar'
import SodaForm from '@/components/form/index'
import { mapState } from 'vuex'
import { getVisitObjectInit, saveVisitObject } from '@/api'
import daphne from '@didi/daphne-sdk-javascript'
import ruleConfig from '@/common/utils/rules-COM'
import { i18n, sprintf } from '@/common/utils/i18n'
const nI18n = {
  gettext: i18n.gettext,
  sprintf
}
export default {
  name: 'addVisitPerson',
  props: {
    roleId: {
      required: false,
      type: Number
    },
    isEdit: {
      required: true,
      type: Boolean
    }
  },
  components: {
    TitleBar,
    SodaForm
  },
  data () {
    return {
      loading: false,
      dataLoaded: false,
      shopId: this.$route.query.shopId,
      formData: {},
      roleList: [],
      contactModeList: [],
      visitObjectList: [],
      phonePreText: '',
      notificationShow: true,
      hasNotificationCloseCache: window.localStorage.getItem('add_person_notification_close') === 'true'
    }
  },
  computed: {
    ...mapState(['login']),
    formConfig () {
      const phoneRule = ruleConfig.telePhone('', nI18n)
      return [
        {
          label: this.$t('Gattaran_0_Role_QDBu' /** 角色 */),
          type: 'rich-select',
          prop: 'roleId',
          props: {
            disabled: this.isEdit,
            options: this.availableRoleList,
            placeholder: this.gettext('请选择')
          },
          rules: {
            required: true
          }
        },
        {
          label: this.gettext('姓名'),
          type: 'input',
          prop: 'name',
          props: {
            placeholder: this.gettext('请输入')
          },
          rules: {
            required: true
          }
        },
        {
          label: this.gettext('电话'),
          type: 'phone',
          prop: 'phone',
          props: {
            placeholder: this.gettext('请输入'),
            preText: this.phonePreText
          },
          rules: {
            ...phoneRule.rules,
            required: true,
            type: 'number'
          },
          messages: phoneRule.messages
        },
        {
          label: this.$t('FoodB_leads_The_relationship_jkYA' /** 倾向联系时间 */),
          type: 'timeRangePicker',
          prop: 'contactTime',
          props: {
            placeholder: this.gettext('请选择')
          },
          rules: {
            custom: (val) => {
              if (!val[0] || !val[1]) {
                return true
              } else {
                const start = +new Date(`1970/01/01 ${val[0]}`)
                const end = +new Date(`1970/01/01 ${val[1]}`)
                return start < end
              }
            }
          },
          messages: {
            custom: this.$t('Gattaran_0_The_end_KvBf' /** 结束时间必须大于开始时间 */)
          }
        },
        {
          label: this.$t('FoodB_optimization_Stimulate_contact_xSSH' /** 倾向联系方式  */),
          type: 'multiSelectNew',
          prop: 'contactMode',
          props: {
            options: this.contactModeList,
            placeholder: this.gettext('请选择')
          }
        }
      ]
    },
    availableRoleList () {
      const exitedRoleIds = this.visitObjectList.map(i => i.roleId)
      return this.isEdit
        ? this.roleList
        : this.roleList.filter(role => !exitedRoleIds.includes(role.value))
    }
  },
  methods: {
    async save () {
      const isValid = await this.$refs.form.validate()
      if (isValid) {
        this.loading = true
        const { shopId } = this
        const { name, phone, contactTime = ['', ''], contactMode = [], roleId } = this.formData
        const res = await saveVisitObject({
          shopId,
          roleId,
          name,
          phone,
          contactTime: [{
            startTime: contactTime ? contactTime[0] : '',
            endTime: contactTime ? contactTime[1] : ''
          }],
          contactMode
        })
        this.loading = false
        if (res) {
          this.$emit('save')
          this.$emit('back')
        }
      }
    },
    back () {
      this.$emit('back')
    },
    closeNotification () {
      this.notificationShow = false
      window.localStorage.setItem('add_person_notification_close', true)
    }
  },
  async mounted () {
    const loading = this.$createToast({ mask: true })
    loading.show()
    // 获取callingCode配置
    const { country } = this.login.userInfo
    const callingCode = daphne.getCallingCode(country)
    this.phonePreText = callingCode

    // 获取拜访相关配置
    const initConf = await getVisitObjectInit({ shopId: this.shopId })
    this.roleList = initConf.roleList.map(i => ({ text: i.value, value: i.key })) || []
    this.contactModeList = initConf.contactModeList.map(i => ({ label: i.value, value: i.key })) || []
    this.visitObjectList = initConf.visitObjectList || []

    // 编辑页获取拜访详情回显表单
    if (this.isEdit) {
      const contactDetail = this.visitObjectList.find(i => i.roleId === this.roleId)
      const { name, phone, contactTime = [], contactMode = [], roleId } = contactDetail

      this.formData.roleId = roleId
      this.formData.name = name
      this.formData.phone = phone
      this.formData.contactTime = contactTime && contactTime.length
        ? [contactTime[0].startTime, contactTime[0].endTime]
        : ['', '']
      this.formData.contactMode = contactMode.map(i => i.key)
    }

    this.dataLoaded = true
    loading.hide()
  }
}
</script>

<style lang="scss" scoped>
.add-visit-person {
  position: relative;
  background-color: #F2F3F6;
  height: 100%;

  .notification {
    display: flex;
    align-items: center;
    width: 100%;
    background: #E9EAEE;
    z-index: 1;
    text-align: left;

    p {
      flex: 1;
      padding: 24px 0 24px 40px;
      font-size: 24px;
      color: #595C66;
      line-height: 32px;
      font-weight: 400;

      .icon-outlined_information {
        margin-right: 6px;
        font-size: 32px;
        vertical-align: middle;
      }
    }

    .richic-close {
      display: flex;
      align-items: center;
      margin: 0 32px;
      flex: 0;
      font-size: 48px;
    }
  }

  &-list-wrapper {
    padding-bottom: 120px;
    background-color: #F2F3F6;
    height: calc(100vh - 100px - 152px);
    box-sizing: border-box;
    overflow: scroll;
  }

  &-form {
    margin: 24px;
    box-sizing: border-box;
    border-radius: 16px;
    background-color: #FFFFFF;

    ::v-deep .rich-form-item {
      padding: 24px;

      .rich-form-label {
        font-size: 24px;
        color: #8D9099;
        line-height: 32px;
        padding-bottom: 16px;
      }
      .rich-form-field {
        font-family: DiDiSans-Pro-Medium;
        font-size: 36px;
        color: #282B33;
        line-height: 44px;
        padding-bottom: 16px;

        .rich-input-wrapper {
          height: auto;
          .rich-input-label-placeholder {
            display: none;
          }
          .rich-input-bottom {
            padding: 0;
          }
        }
      }
    }
  }

  .save {
    position: absolute;
    bottom: 0;
    width: 100%;
    background-color: #FFFFFF;
    padding: 20px 24px 40px 24px;
    box-sizing: border-box;
    &-btn {
      font-family: DiDiSans-Pro-Bold;
      font-size: 32px;
      color: #FFFFFF;
      text-align: center;
      line-height: 40px;
    }
  }
}
</style>
